import { Plugin, Config } from '@tencent/aegis-core';
import Aegis, { WebConfig } from '../aegis';

let plugin = new Plugin({ name: 'shadowLog' });
// 加载shadowLog
function loadShadowLog(scriptUrl: string, config: WebConfig | Config) {
  let Flog: any = null;
  let ShadowLogAegisPlugin: any = null;

  const pluginUrl = config.shadowLog.pluginUrl || scriptUrl;

  function initShadowLog(aegis: Aegis) {
    // 两个构造函数都准备好的时候才开始运行
    if (!Flog || !ShadowLogAegisPlugin) {
      return;
    }

    const { id, uin } = config;
    const url = Aegis.urls.aegisCollect;
    const preservedDay = 7; // 保存7天

    try {
      class ShadowLog extends ShadowLogAegisPlugin {
        constructor(config: WebConfig) {
          super(config);
        }
        init(options: any) {
          const { namespace } = options;

          const dbConfig: any = {
            name: namespace,
          };

          const cfgs: any = {
            dbConfig,
            lookupUrl: `${url}/shadowLogAuto?id=${id}&uin=${uin}`,
            uploadUrl: `${url}/shadowLog`,
            preservedDay,
            id,
            uin,
            sessionId: Aegis._sessionID,
          };
          const flog = new Flog(cfgs);
          this.flog = flog;

          return super.init(options);
        }
        postMessage(message: any) {
          const { type, data } = message;
          // 仅支持通过 flog 写入到 indexedDB 中
          if (type === 'write') {
            this.flog.add(data);
          }
        }
        report() {
          this.flog.uploadLogs();
        }
      }
      const shadow = new ShadowLog(config.shadowLog);
      // 抛出 shadowLog 实例，开发者可以通过该实例在实例上做一些操作
      aegis.lifeCycle.emit('onShadowLogInit', shadow);
    } catch (e) {
      console.log(e);
    }
  }

  Aegis.useAsyncPlugin(Aegis.urls.flog, {
    exportsConstructor: 'Flog',
    onAegisInitAndPluginLoaded(aegis: Aegis, ExportedConstrocutor: any) {
      Flog = ExportedConstrocutor;
      initShadowLog(aegis);
    },
  });

  Aegis.useAsyncPlugin(pluginUrl, {
    exportsConstructor: 'ShadowLogAegisPlugin',
    onAegisInitAndPluginLoaded: (aegis: Aegis, ExportedConstrocutor: any) => {
      ShadowLogAegisPlugin = ExportedConstrocutor;
      initShadowLog(aegis);
    },
  });
}

if (SHADOW_LOG) {
  plugin = new Plugin({
    name: 'shadowLog',
    onNewAegis(aegis) {
      loadShadowLog(Aegis.urls.shadowLog, aegis.config);
    },
  });
}

export default plugin;
